import React from "react"
import Layout from "../components/layout"
import { graphql } from "gatsby"
import SakhalinComponent from "../components/sakhalin/sakhalin.component"

const AirQualityMonitoringNetworkInThePacificIslands = () => {
  return (
    <Layout>
      <SakhalinComponent />
    </Layout>
  )
}

export default AirQualityMonitoringNetworkInThePacificIslands

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
